import { PROFILE_INFO_GRID_CLASS_NAME, DASHED_DROPZONE_GRID_CLASS_NAME } from '../../constants/grid';

const profileInfoGrid = ({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: 15,
  padding: 30,
});

const dashedDropzone = ({ theme }) => ({
  padding: theme.spacing(3),
  borderWidth: 2,
  borderStyle: 'dashed',
  borderColor: theme.palette.primary.main,
  borderRadius: 12,
  backgroundColor: 'transparent',
});

const MuiGrid = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${PROFILE_INFO_GRID_CLASS_NAME}`]: profileInfoGrid({ theme }),
      [`&.${DASHED_DROPZONE_GRID_CLASS_NAME}`]: dashedDropzone({ theme }),
    }),
  },
};

export default MuiGrid;
